export default function LogoutMenuIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.07187 21.2033C4.44221 21.2033 3.90562 20.9815 3.46212 20.538C3.01862 20.0945 2.79688 19.5579 2.79688 18.9283V5.07175C2.79688 4.44209 3.01862 3.9055 3.46212 3.462C3.90562 3.0185 4.44221 2.79675 5.07187 2.79675H12.0479V5.07175H5.07187V18.9283H12.0479V21.2033H5.07187ZM15.9224 17.287L14.3501 15.6518L16.8641 13.1375H8.95237V10.8625H16.8641L14.3501 8.34825L15.9224 6.713L21.2034 12L15.9224 17.287Z"
        fill="#FFFFFD"
      />
    </svg>
  );
}
